module.exports = __webpack_public_path__ + "img/3_5.d5bd113f.png";